<template>
  <el-drawer size="1000px"
             :withHeader="false"
             :visible.sync="wxOfficialVisible"
             :close-on-press-escape="false"
             :wrapperClosable="false"
             :before-close="handleClickClose">
    <div class="drawer_wrap">
      <div class="drawer_header">
        <h3 class="title">公众号设置</h3>
        <i class="el-icon-close" @click="handleClickClose"></i>
      </div>
      <div class="drawer_body">

        <el-form size="small"
                 ref="OfficialForm"
                 label-position="top"
                 label-width="175px"
                 :model="OfficialForm"
                 :rules="OfficialFormRules" v-loading="loading">
          <el-form-item label="公众号名称：" prop="official_account_name">
            <el-input placeholder="请输入公众号名称" v-model="OfficialForm.official_account_name"></el-input>
          </el-form-item>

          <el-form-item label="公众号二维码：" prop="cover">
            <div class="upload_img_wrap">
              <div v-if="OfficialForm.official_account_qrcode" class="img_wrap">
                <img :src="OfficialForm.official_account_qrcode" alt=""  @click="handleClickUpload">
                <i class="el-icon-circle-close" @click="handleClickCoverDel"></i>
              </div>
              <div class="upload_wrap" v-else  @click="handleClickUpload">
                <i class="el-icon-upload"></i>
                <div>点击上传</div>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="AppID：" prop="appid">
            <el-input placeholder="请输入AppID" v-model="OfficialForm.appid"></el-input>
          </el-form-item>
          <el-form-item label="AppSecret：" prop="appsecret">
            <el-input placeholder="请输入AppSecret" v-model="OfficialForm.appsecret"></el-input>
          </el-form-item>

          <el-form-item label="通知模版：" prop="template_json">
            <el-input type="textarea" :rows="5" placeholder="请输入通知模版" v-model="OfficialForm.template_json"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer_footer">
        <el-button size="small" @click="handleClickClose">取消</el-button>
        <el-button :disabled="btnDisabled" size="small" type="primary" @click="handleClickConfirm">确定
        </el-button>
      </div>
    </div>
  </el-drawer>


</template>
<script>

import { accountAdd ,accountEdit ,accountDetails } from '@/api'
import { uploadImg, getOSSData } from "@/utils/uploadOss";
export default {
  name: 'wxOfficial',
  props: {
    wxOfficialVisible: {
      type: Boolean,
      default: false,
    },
    companyId: {
      type: Number,
      default: 0,
    },
    officialAccountId: {
      type: Number,
      default: 0,
    }

  },
  data () {
    return {
      OfficialForm: {
        official_account_name:'',
        official_account_qrcode:'',
        appid: '',
        appsecret: '',
        template_json:''
      },
      OfficialFormRules: {
        official_account_name: [{required: true, trigger: 'blur', message: '请输入公众号名称'}],
        appid: [{required: true, trigger: 'blur', message: '请输入AppId'}],
        appsecret: [{required: true, trigger: 'blur', message: '请输入App密钥'}],
      },
      loading:false,
      btnDisabled:false
    }
  },
  created () {
  },
  mounted () {
    if(this.companyId != 0){
      this.OfficialForm.company_id =  this.companyId
      this.getdetail()
    }
  },
  methods: {
    // 编辑时获取详情
    getdetail(){
      this.loading = true
      accountDetails({
        company_id: this.companyId
      }).then(res => {
        if(res.code === 200 ){
          let {data} = res
          this.OfficialForm = data
        }
        this.loading = false
      })
    },

    // 上传图片
    handleClickUpload(){
      let that = this
      const input = document.createElement('input')
      input.setAttribute('type', 'file')
      input.setAttribute('multiple', 'false')
      input.setAttribute('accept', 'image/png,image/jpeg,image/gif,image/jpg')
      input.click()
      input.onchange = function () {
        const files = this.files[0]
        if (files.size) {
          that.loading = true
          uploadImg(files).then(res => {
            that.OfficialForm.official_account_qrcode =  res.file_path
            that.loading = false
            that.$message.success('上传成功')
          }).catch(() => {
            that.loading = false
          })
        }
      }
    },
    // 删除图片
    handleClickCoverDel(){
      this.OfficialForm.official_account_qrcode = ''
      this.$forceUpdate()
    },
    //取消事件
    handleClickClose () {
      //重置表格
      this.$refs.OfficialForm.resetFields()
      //关闭对话框
      this.$emit('update:wxOfficialVisible', false)
    },
    //确定事件
    handleClickConfirm () {
      this.$refs.OfficialForm.validate(valid => {
        if (valid) {

          if(!this.OfficialForm.official_account_id){
            accountAdd(this.OfficialForm).then(res=>{
              // 验证通过调用新增菜单接口
              this.$message.success('新增成功')
              //调用取消事件
              this.handleClickClose()
              //父页面刷新列表
              this.$emit('success')
            })
          }else{
            accountEdit(this.OfficialForm).then(res=>{
              // 验证通过调用新增菜单接口
              this.$message.success('编辑成功')
              //调用取消事件
              this.handleClickClose()
              //父页面刷新列表
              this.$emit('success')
            })
          }


        } else {
          return false
        }
      })
    },
  },

}
</script>
<style lang="scss" scoped>
.hint {
  font-size: 12px;
  line-height: 16px;
  color: #888888;
  margin-top: 5px;
}
.upload_img_wrap{
  width: 148px;height: 148px;
}
.upload_img_wrap img{
  width: 146px;
  height: 146px;
}
</style>
